import { makeAutoObservable } from 'mobx';
import ErrorUtil from '../error/ErrorUtil';
import { CommonAPI } from '../util/ApiUtil';
import { FetchStatus } from '../util/FetchStatus';

interface ExistingProductHolder {
  status: FetchStatus;
  data: string;
}

class Go3Store {
  public existingProduct: ExistingProductHolder = { data: null, status: FetchStatus.UNINITIALIZED };
  public previousCustomerId: number = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public async fetchExistingApp(customerId: number) {
    if (!customerId) {
      this.setExistingProductState(null, FetchStatus.FETCHED);
      return;
    }
    if (customerId === this.previousCustomerId) {
      return;
    }
    if (![FetchStatus.FETCHING].includes(this.existingProduct.status)) {
      this.setExistingProductState(customerId, FetchStatus.FETCHING, null);
      try {
        const response = await CommonAPI.get<string>(`/product/go3-product`);
        this.setExistingProductState(customerId, FetchStatus.FETCHED, response.data);
      } catch (e) {
        ErrorUtil.pushErrorToTeliaRumAndLog(e as Error);
        this.setExistingProductState(customerId, FetchStatus.ERROR, null);
      }
    }
  }

  private setExistingProductState(customerId: number, status: FetchStatus, data?: string) {
    this.previousCustomerId = customerId;
    this.existingProduct = { status, data };
  }
}

export default Go3Store;
